import axiosBase from "axios";

const axios = (isGraphQLServerRequest, params, isFormData) =>
    axiosBase.create({
        baseURL: isGraphQLServerRequest
            ? import.meta.env.VITE_GRAPHQL_SERVER
            : import.meta.env.VITE_REACT_DRIVE_MANAGEMENT_SERVER,
        headers: { "Content-Type": isFormData ? "multipart/form-data" : "application/json" },
        timeout: 3000 * 3000,
        ...(params && {
            params: { ...params },
        }),
    });

export default axios;
